<div class="container-fluid">
    <div class="row pt-4 pl-4" style="font-size: 22px !important;
    font-weight: 400;
    color: #424242;">
      <h5><i class="fa fa-circle" style="color:#800000"></i> &nbsp;Diary Reports-Client Wise</h5>
    </div>
  <div id="mainContent" class="container">
    <div class="modal-body">
      
        <div class="row">
          <div class="col-sm-4">
            <div class="row">
              <div class="col-sm-4">
                <label for="approversName" class="col-form-label"
                  >Financial Year</label
                >
              </div>
              <div class="col-sm-6">
                <select
                  class="form-control form-control-xs mt-1"
                  [(ngModel)]="selectedFinancialYear"
                  (change)="onFYSelected()">
                  <option value="">Select Year</option>
                  <option *ngFor="let selectedFinancialYear of financialList" [ngValue]="selectedFinancialYear">
                    {{ selectedFinancialYear.name }}
                  </option>
                </select>
              </div>
            </div>
          </div>
          <div class="col-sm-4">
            <div class="row">
              <label class="col-sm-4 col-form-label">Clients</label>
              <div class="col-sm-6">
                  <mat-form-field appearance="legacy" style="width: 100%">
                    <mat-select
                      multiple
                      [(ngModel)]="selectClient"
                      #designateClient="ngModel"
                    >
                      <mat-option
                        #clientChecked
                        (click)="selectAllClient(designateClient, clientList)"
                        [value]="0"
                        >Select All
                      </mat-option>
                      <mat-option
                        (click)="getAllAssignmentDetails()"
                        #clientChecked
                        *ngFor="let client of clientList"
                        [value]="client"
                      >
                        {{ client.name }}
                      </mat-option>
                    </mat-select>
                  </mat-form-field>
                </div>
              </div>
          </div>
          <div class="col-sm-4">
            <!-- <button
              id="saveFyBtn"
              name="saveFyBtn"
              type="button"
              class="btn btn-sm btn-block btn-outline-theme"
              (click)="onViewReport()"
            >
              View Report
            </button> -->
            <div class="row">
              <label class="col-sm-4 col-form-label">Assignments</label>
              <div class="col-sm-6">
                <mat-form-field appearance="legacy" style="width: 100%">
                  <mat-select
                    multiple
                    [(ngModel)]="selectAssignment"
                    #designateAssignment="ngModel"
                  >
                    <mat-option
                      (click)="
                        selectAllAssignment(designateAssignment, assignmentList)
                      "
                      [value]="0"
                      >Select All
                    </mat-option>
                    <mat-option
                      #item
                      *ngFor="let assignment of assignmentList"
                      [value]="assignment"
                    >
                      {{ assignment.name }}
                    </mat-option>
                  </mat-select>
                </mat-form-field>
              </div>
            </div>
          </div>
        </div>
  
        <div class="row mt-3">
          <div class="col-sm-4">
            <div class="row">
              <div class="col-sm-4">
                <label for="approversName"
                  >From Date
                </label>
              </div>
              <div class="col-sm-6">
                <div class="input-group">
                  <input
                    class="form-control form-control-xs"
                    placeholder="dd/mm/yyyy"
                    name="fromDate"
                    ngbDatepicker
                    #fromDate="ngbDatepicker"
                    [placement]="'bottom'"
                    [maxDate]="maxDate"
                    (dateSelect)="onFromDateChange($event)"
                    [class.is-invalid]="formErrors.fromDate && formSubmitted"
                    matTooltip="{{ formErrors.fromDate }}"
                    matTooltipPosition="above"
                    matTooltipClass="warn-tooltip"
                    matTooltipClass="warn-tooltip"
                  />
                  <div class="input-group-append">
                    <button
                      class="btn btn-outline-theme fa fa-calendar btn-xs"
                      (click)="fromDate.toggle()"
                      type="button"
                    ></button>
                  </div>
                </div>
              </div>
            </div>
          </div>
  
          <div class="col-sm-4">
            <div class="row">
              <div class="col-sm-4">
                <label for="toDate" class="form-label"
                  >To Date
                </label>
              </div>
              <div class="col-sm-6">
                <div class="input-group">
                  <input
                    class="form-control form-control-xs"
                    placeholder="dd/mm/yyyy"
                    name="toDate"
                    ngbDatepicker
                    (dateSelect)="onToDateChange($event)"
                    #toDate="ngbDatepicker"
                    [maxDate]="maxDate"
                    [placement]="'bottom'"
                    [class.is-invalid]="formErrors.toDate && formSubmitted"
                    matTooltip="{{ formErrors.toDate }}"
                    matTooltipPosition="above"
                    matTooltipClass="warn-tooltip"
                  />
                  <div class="input-group-append">
                    <button
                      class="btn btn-outline-theme fa fa-calendar btn-xs"
                      (click)="toDate.toggle()"
                      type="button"
                    ></button>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="col-sm-2">
            <button
              (click)="exportToExcelClick()"
              class="btn btn-sm btn-block btn-outline-theme"
            >
              <i class="fa fa-file-excel-o mr-2"></i>Export to Excel
            </button>
          </div>
        </div>
    </div>
  </div>
  
  <!-- <div class="container" id="mainContent">
    <div class="pt-3" *ngIf="showReports">
      <div class="row justify-content-center text-center">
        <span class="bg-theme-title"
          >P G BHAGWAT LLP, Chartered Accountants
        </span>
      </div>
      <div class="row justify-content-center text-center ">
        <span>Suite 102, "Orchard", Dr Pai Marg, Baner, Pune - 411045 </span>
      </div>
  
      <div class="row pt-2">
        <div class="col-md-10">
          <span style="padding-left: 40%" class="bg-theme-title"
            >Diary Reports From : {{ fdate | date: "dd-MMM-yyyy" }} To
            {{ tdate | date: "dd-MMM-yyyy" }} </span
          >
          <br />
          <span style="font-size: 15px;font-weight: bold;"
            >Employee Name: </span> <span>{{ empFName }} {{ empLName }}</span
          >
        </div>
      </div>
  
      <div class="row">
        <div class="col-md-12">
          <table
            class="table table-bordered table-sm table-striped"
            style="display: block; overflow-x: auto; white-space: nowrap"
          >
            <thead class="">
              <tr>
                <th>Diary Date</th>
                <th>Day</th>
                <th>Debit Hours</th>
                <th>Credit Hours</th>
                <th>Client Name</th>
                <th>Assignment</th>
                <th>Assignment For FY</th>
                <th>Task</th>
                <th>Work Performed</th>
                <th>In Time</th>
                <th>Out Time</th>
                <th>No Of Hours</th>
                <th>Travelling From</th>
                <th>Mode</th>
                <th>Distance in Kms</th>
                <th>Rate</th>
                <th>Amount</th>
                <th>Approver Name</th>
                <th>Diary Approval Date</th>
                <th>Status</th>
              </tr>
            </thead>
            <tbody>
              <tr
                *ngFor="
                  let rep of reports
                    | slice: (page - 1) * pageSize:page * pageSize
                "
              >
                <td>{{ rep.diaryDate | date: "dd-MMM-yyyy" }}</td>
                <td>{{ rep.diaryDate | date: "EEEE" }}</td>
                <td>{{ rep.debitHrs + "." + rep.debitMin }}</td>
                <td>{{ rep.creditHrs + "." + rep.creditMin }}</td>
                <td>{{ rep.clientName }}</td>
                <td>{{ rep.assignment }}</td>
                <td>{{ rep.assignmentFYYear }}</td>
                <td>{{ rep.task }}</td>
                <td>{{ rep.workPerformed }}</td>
                <td>{{ rep.inTimeHr + "." + rep.inTimeMin }}</td>
                <td>{{ rep.outTimeHr + "." + rep.outTimeMin }}</td>
                <td>{{ rep.noOfHoursHr + "." + rep.noOfHoursMin }}</td>
                <td>{{ rep.travellingFrom }}</td>
                <td>{{ rep.mode }}</td>
                <td>{{ rep.distanceInKm }}</td>
                <td>{{ rep.rate }}</td>
                <td>{{ rep.amount }}</td>
                <td>
                  {{ rep.approver == null ? "Self Approved" : rep.approver }}
                </td>
                <td>{{ rep.approvalDate | date: "dd-MMM-yyyy" }}</td>
                <td>{{ rep.status }}</td>
              </tr>
              <tr *ngIf="reports.length != 0 && showRow">
                <td>Total</td>
                <td></td>
                <td>{{ sumOfDebitedHours }}</td>
                <td>{{ sumOfCreditedHours }}</td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td>{{ sumOfNumberOfHours }}</td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td>{{ totalAmount }}</td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
              </tr>
  
              <tr *ngIf="reports.length == 0">
                <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td>No Entries available</td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
              </tr>
            </tbody>
          </table>
        
          <ngb-pagination
            (pageChange)="pageChanged($event)"
            [pageSize]="pageSize"
            [maxSize]="20"
            [boundaryLinks]="true"
            [collectionSize]="reports.length"
            [(page)]="page"
            aria-label="Default pagination"
          ></ngb-pagination>
        </div>
      </div>
    </div>
  </div> -->
  </div>